import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { Box, Rating } from '@bridebook/ui';
import { Reviews } from '@bridebook/web/app-shared/lib/supplier/types';
import componentStyles from './supplier-head-reviews-testimonials-info.style';

interface IProps {
  feedbackCount: number;
  isSupplierLoaded: boolean;
  onTestimonialsClick?: () => void;
  reviews: Reviews;
}

const DEFAULT_STARS_TO_RENDER = '5';

const TestimonalInfo = ({
  feedbackCount,
  isSupplierLoaded,
  onTestimonialsClick,
  reviews: { hasTestimonials, hasReviews, stars },
}: IProps) => {
  const { t } = useTranslation('supplier');

  const caption = t('noReviews.caption');

  const isActive = hasTestimonials || hasReviews;

  const styles = componentStyles({ isActive });

  const hasOnTestimonialsClick = Boolean(onTestimonialsClick);

  const handleOnTestimonialsClick = useCallback(() => {
    if (!hasReviews && !hasTestimonials) return;
    onTestimonialsClick?.();
  }, [hasReviews, hasTestimonials, onTestimonialsClick]);

  const renderReviews = (starsToRender: string) => (
    <Box style={styles.reviewsWrap(hasOnTestimonialsClick)}>
      <Box mr={2}>
        <Rating rating={Number(starsToRender)} />
      </Box>
      <Box>({feedbackCount})</Box>
    </Box>
  );

  return (
    <Box style={styles.wrapper} onClick={handleOnTestimonialsClick}>
      {hasReviews && renderReviews(String(stars))}
      {hasTestimonials && !hasReviews && renderReviews(DEFAULT_STARS_TO_RENDER)}
      {!hasReviews && !hasTestimonials && isSupplierLoaded && <Box>{caption}</Box>}
    </Box>
  );
};

export default TestimonalInfo;
